import axios from 'axios'

import qs from 'qs'
import {CONF} from '@/assets/js/config'
import router from "../router";

// 后端接口地址
// axios.defaults.baseURL = process.env.VUE_APP_URL

const xhr = axios.create({
    baseURL: CONF.SERVER,
    timeout: 10e3
})

// 请求拦截
xhr.interceptors.request.use(config => {
    return config
}, e => Promise.reject(e))

xhr.interceptors.response.use(res => {

    if (res.data.err == 102){
        router.push("Login")
    }
    if (res.data.err == 106){
        router.push("Login")
        return
    }

    return res.data
}, e => {
    return Promise.reject(e)
})

async function xhrGet(url, data) {
    if (!data) {
        data = {}
    }
    let tk = sessionStorage.getItem('userToken')
    let lang = sessionStorage.getItem('lang')
    if (!lang ) {
        lang = CONF.LANG
        sessionStorage.setItem('lang', lang)
    }
    data.tk = tk
    data.lang = lang
    return xhr({
        url: url,
        params: data
    })
}

async function xhrPost(url, data) {
    if (!data) {
        data = {}
    }
    let tk = sessionStorage.getItem('userToken')
    // let lang = sessionStorage.getItem('lang')
    let lang = CONF.LANG
    if (!lang ) {
        lang = CONF.LANG
        sessionStorage.setItem('lang', CONF.LANG)
    }
    // if (!tk || tk.length<32) {
    //     tk = await getTk()
    //     localStorage.setItem('tk', tk)
    // }
    data.tk = tk
    data.lang = lang
    return xhr({
        url: url, 
        method: 'post',
        // data: qs.stringify(data)
        data
    })
}

function getTk() {
    return xhr.get('/index/getToken')
}

export {xhr,xhrGet,xhrPost,getTk}